import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const AUTH_API_URL = `${API_BASE_URL}/api/Auth`;

export const registerUser = async (username: string, email: string, password: string) => {
  try {
    const response = await axios.post(`${AUTH_API_URL}/register`, { username, email, password });
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || error.message;
  }
};

export const loginUser = async (username: string, password: string) => {
  try {
    const response = await axios.post(`${AUTH_API_URL}/login`, { username, password });
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || error.message;
  }
};
